import { Component } from '@angular/core';
import {ModalComponent} from "../../ui/modal/modal.component";
import {ModalTitleComponent} from "../../ui/modal-title/modal-title.component";
import {TranslateModule} from "@ngx-translate/core";
import {ModalBodyComponent} from "../../ui/modal-body/modal-body.component";
import {ModalFooterComponent} from "../../ui/modal-footer/modal-footer.component";
import {ButtonComponent} from "../../ui/button/button.component";
import {SharedModule} from "../../../shared/shared.module";
import {OverlayRef} from "@angular/cdk/overlay";
import {ModalConfig} from "../../../models/modal-config";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-delete-confirm-modal',
  standalone: true,
  imports: [
    ModalComponent,
    ModalTitleComponent,
    TranslateModule,
    SharedModule,
    ModalBodyComponent,
    ModalFooterComponent,
    ButtonComponent,
    NgIf,
  ],
  templateUrl: './delete-confirm-modal.component.html',
  styleUrl: './delete-confirm-modal.component.scss'
})
export class DeleteConfirmModalComponent {
  confirm: () => Promise<void>;
  type: string;
  name: string;
  loading = false;
  error = false;

  constructor(private overlayRef: OverlayRef, config: ModalConfig) {
    this.confirm = config.data.confirm;
    this.type = config.data.type;
    this.name = config.data.name;
  }

  async doConfirm() {
    if (this.loading) return;

    this.loading = true;
    this.error = false;

    try {
      await this.confirm();
      this.close();
    } catch (e) {
      console.error(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.overlayRef.dispose();
  }
}
